import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from 'config/config';

type AccessControlLogRow = {
  _id?: string;
  endpoint?: string;
  httpStatus?: number;
  createdAt?: string;
  clientIp?: string;
  deviceAccessKey?: string;
  requestBody?: unknown;
  responseBody?: unknown;
  userAgent?: string;
};

@Component({
  selector: 'app-access-control-logs',
  templateUrl: './access-control-logs.component.html',
  styleUrls: ['./access-control-logs.component.css'],
})
export class AccessControlLogsComponent implements OnInit {
  readonly secret = '68a7f2c14e9b8d3a2f6c0e91';

  loading = false;
  error = '';
  logs: AccessControlLogRow[] = [];
  endpointFilter: '' | 'validate-qr' | 'validate-rfid' = '';
  limit = 100;
  expandedId: string | null = null;

  constructor(
    private http: HttpClient,
    private config: Configuration,
  ) {}

  ngOnInit(): void {
    this.loadLogs();
  }

  loadLogs(): void {
    this.loading = true;
    this.error = '';

    const params: string[] = [`limit=${this.limit}`];
    if (this.endpointFilter) {
      params.push(`endpoint=${this.endpointFilter}`);
    }

    const url = `${this.config.Server}api/accesscontrol/logs/${this.secret}?${params.join('&')}`;

    this.http.get<{ status: boolean; count: number; data: AccessControlLogRow[] }>(url).subscribe({
      next: (res) => {
        this.logs = Array.isArray(res?.data) ? res.data : [];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.error =
          err?.status === 404
            ? 'Not found (invalid secret or API unavailable).'
            : err?.message || 'Failed to load access control logs.';
      },
    });
  }

  toggleExpand(id: string | undefined): void {
    if (!id) {
      return;
    }
    this.expandedId = this.expandedId === id ? null : id;
  }

  formatJson(value: unknown): string {
    try {
      return JSON.stringify(value ?? {}, null, 2);
    } catch {
      return String(value);
    }
  }

  statusClass(httpStatus: number | undefined, responseBody: unknown): string {
    const body = (responseBody || {}) as { status?: string; valid?: boolean };
    if (httpStatus && httpStatus >= 400) {
      return 'badge-err';
    }
    if (body.valid === true || body.status === 'VALID') {
      return 'badge-ok';
    }
    if (body.status) {
      return 'badge-warn';
    }
    return 'badge-muted';
  }

  responseStatus(responseBody: unknown): string {
    const body = (responseBody || {}) as { status?: string };
    return body.status || '—';
  }
}
